import NavbarTab from './navbarItem/NavbarTab'
import NavbarSelect from './navbarItem/NavbarSelect'
import NavbarSearch from './navbarItem/NavbarSearch'
import NavbarCard from './navbarItem/NavbarCard'
import NavbarProfile from './navbarItem/NavbarProfile'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import auth from 'utils/Auth'


const Navbar = ({getAllBasket, logoPath}) => {
  const location = useLocation()
  const navigate = useNavigate();
  const { navbarColor } = useSelector(state => state.general)
  const handleChangeLang = (e) => {
    localStorage.setItem('lang',JSON.stringify(e.value))
    window.location.reload()
  }
  const logoClick=()=>{
    navigate('/')
  }
  const langs = [
    {label:'TR',value:'tr'},{label:'EN',value:'en'}
  ]
  const authToken = auth.getGuestToken() || auth.getToken()
	const parameters = auth.getUserChoises();
  const isSearchOpen = parameters?.deliveryType &&
  parameters?.neighbourhoodId &&
  parameters?.restaurantId &&
  (parameters?.deliveryType == 1 || parameters?.regionId)
  return (
    <div className={`navbarPr ${(location.pathname == "/" && navbarColor == false) ? "navbarAbsolute" : "navbarRelative"}`}>
      <div className={`navbar`}>
        <img className='navbar-logo' onClick={logoClick} src={logoPath} alt="" />
        {
          authToken && <div className='navbar-container'>
            <NavbarTab isSearchOpen={isSearchOpen} />
            {
              isSearchOpen && <>
                <NavbarSelect />
                <NavbarSearch />
              </>
            }
          </div>
        }
        {authToken && <NavbarCard getAllBasket={getAllBasket} />}
         {!authToken && <NavbarSearch />}
        <NavbarProfile handleChangeLang={handleChangeLang} langs={langs} />
      </div>
      {/* <MobileSearch /> */}
    </div>
  )
}

export default Navbar